export default __webpack_public_path__ + "static/media/Game_2_Sound_Loop.ea2a7824.wav";